'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const CalendarGridDayRowContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridDayRowContext.displayName = "CalendarGridDayRowContext";
export function useCalendarGridDayRowContext() {
  const context = React.useContext(CalendarGridDayRowContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: CalendarGridDayRowContext is missing. ' + '<CalendarGrid.DayCell /> and <CalendarGrid.DayEvent /> must be placed within <CalendarGrid.DayRow />. ' + 'Ensure the component hierarchy is correct.' : _formatErrorMessage(257));
  }
  return context;
}